import { render } from "./SpamNumberPage.vue?vue&type=template&id=35fb1c08&ts=true"
import script from "./SpamNumberPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SpamNumberPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/spam-number/SpamNumberPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35fb1c08"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35fb1c08', __exports__)) {
    api.reload('35fb1c08', __exports__)
  }
  
  module.hot.accept("./SpamNumberPage.vue?vue&type=template&id=35fb1c08&ts=true", () => {
    api.rerender('35fb1c08', render)
  })

}


export default __exports__